import { getOdataRootUrl } from '@bingads-webui-react/copilot-utils';
import axios, { AxiosRequestConfig } from 'axios';

const MAXIMUM_FETCH_COUNT = 10000;

interface IFetchCriterionUrlProps {
  accountId: string;
  customerId: string;
  campaignId: string;
  adGroupId?: string;
}

export interface IFetchCriterionProps extends IFetchCriterionUrlProps {
  ccToken: string;
}

const CriterionParams = {
  $top: MAXIMUM_FETCH_COUNT,
  $count: 'true',
  $filter: "isof(Criterion,'Model.AgeCriterion') or isof(Criterion,'Model.GenderCriterion') or isof(Criterion,'Model.DeviceCriterion') or isof(Criterion,'Model.CompanyNameCriterion') or isof(Criterion,'Model.IndustryCriterion') or isof(Criterion,'Model.DayTimeCriterion') or isof(Criterion,'Model.JobFunctionCriterion')",
};

export function fetchCriterionUrl({
  accountId,
  customerId,
  campaignId,
  adGroupId,
}: IFetchCriterionUrlProps): string {
  if (adGroupId) {
    return `${getOdataRootUrl()}/ODataApi/Campaign/V2/Customers(${customerId})/Accounts(${accountId})/Campaigns(${campaignId})/AdGroups(${adGroupId})/AdGroupCriterions/Model.AdGroupCriterion`;
  }
  return `${getOdataRootUrl()}/ODataApi/Campaign/V2/Customers(${customerId})/Accounts(${accountId})/Campaigns(${campaignId})/CampaignCriterions/Model.CampaignCriterion`;
}

export function fetchCriterionData({
  accountId,
  customerId,
  campaignId,
  adGroupId,
  ccToken,
}: IFetchCriterionProps) {
  const url = fetchCriterionUrl({
    accountId,
    customerId,
    campaignId,
    adGroupId,
  });

  const params = CriterionParams;

  return axios.get(url, {
    headers: {
      Authorization: ccToken,
    },
    params,
  } as AxiosRequestConfig);
}
